var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.initIsShowPopup)?_c('div',{attrs:{"id":"popup_ok"}},[_c('div',{staticClass:"popup_ok_box"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.initPopupOkMessage)}}),_c('a',{on:{"click":_vm.closePopup}},[_vm._v("확인")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }